// Events for Google Analytics 4. They are sent only while the tag is loaded,
// that is after "Accept" (common/consent.js); otherwise every call does nothing.
const send = (name, params) => {
  if (typeof window === 'undefined' || !window.__cpGa4) return;
  if (typeof window.gtag === 'function') window.gtag('event', name, params);
};

// platform: mac, windows or linux (the /download/<platform>/ address);
// location: which button was clicked, e.g. hero or nav.
export const trackDownload = (platform, extension, location) =>
  send('download_click', { platform, file_extension: extension, location });

// Hero film: hero_video_play (trigger: autoplay or user), hero_video_progress
// (video_percent: 25, 50, 75) and hero_video_complete. HeroVideo decides when.
export const trackHeroVideo = (name, params, videoUrl) =>
  send(name, { location: 'hero', video_url: videoUrl, ...params });

// location: where the link to the interactive demo sits, e.g. hero.
export const trackDemoCta = (location) => send('demo_cta_click', { location });

// location: where the link to the audit cases (#case_studies) sits, e.g. hero.
// A click means the visitor wants more proof: a lead signal.
export const trackCasesLink = (location) => send('cases_link_click', { location });

// Copy of the "brew install cloudpouch" command (macOS visitors only).
export const trackBrewCopy = () => send('brew_copy_click', {});

const itemOf = (plan) => ({
  item_id: plan.id,
  item_name: plan.name,
  price: plan.price,
  quantity: 1,
});

// GA4 recommended event for the click on a Buy button.
export const trackBuy = (plan) =>
  send('begin_checkout', {
    currency: 'USD',
    value: plan.price,
    items: [itemOf(plan)],
  });

// GA4 recommended event for a finished checkout. The figures come from the
// Paddle checkout event (Paddle's own measure-conversion guide uses the same
// fields); Paddle stays the record of sales, this one can miss buyers who
// close the tab first or block the tag.
export const trackPurchase = (plan, checkout) => {
  const customer = (checkout && checkout.prices && checkout.prices.customer) || {};
  send('purchase', {
    transaction_id: checkout && checkout.id,
    currency: customer.currency || 'USD',
    value: customer.total !== undefined ? customer.total : plan.price,
    tax: customer.total_tax,
    items: [itemOf(plan)],
  });
};

// Interactive demo (the iframe). location: home or demo-page; trigger: how the demo
// started, scroll (frame came into view), button or page_load (the /demo/ page).
export const trackDemoOpen = (location, trigger) => send('demo_open', { location, trigger });

// First click inside the demo ("watched and clicked"), then one demo_interaction per
// distinct element (DemoEmbed limits the count). target: short element name from the demo
// (never typed text); step: the guide step on screen, empty when the guide is off.
export const trackDemoFirstInteraction = (location, target, step) =>
  send('demo_first_interaction', { location, target, step });
export const trackDemoInteraction = (location, target, step) =>
  send('demo_interaction', { location, target, step });
